import { createAction, props } from '@ngrx/store';
import { UIError, UILoading } from './ui.interface';

export const SET_ERROR = createAction(
  '[UI] Error UI',
  props<{ uiError: UIError }>()
);

export const SET_LOADING = createAction(
  '[UI] Loading UI',
  props<{ uiLoading: UILoading }>()
);

export const SET_IMAGE_UPLOAD = createAction(
  '[UI] Image Upload',
  props<{ isImageUpload: boolean }>()
);
